import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { TrackingEvent } from './types';

const trackEvent = (event: TrackingEvent) =>
  action(ActionTypes.TRACK_EVENT, { event });

export default trackEvent;
